import { DataPointWithValue } from '@src/types/DataPoint';
import { getDataPointCollectionByPointNamesAndControllerId } from '../utils';

export const Beaumont_Device_Points_Config = {
  UNIT_POINTS: [
    {
      label: 'kW',
      pointName: 'kW',
      pointAlias: 'kw',
    },
    {
      label: 'kVAR',
      pointName: 'kVAR',
      pointAlias: 'kvar',
    },
    {
      label: 'SOC',
      pointName: 'SOC',
      pointAlias: 'unitController_SOC_float',
    },
    {
      label: 'Racks Online',
      pointName: 'racksonline',
      pointAlias: 'unitController_racksonline',
    },
    {
      label: 'Inv Status',
      pointName: 'InvStatus',
      pointAlias: 'unitController_InvStatus_string',
    },
    {
      label: 'Run Mode',
      pointName: 'RunMode',
      pointAlias: 'unitController_RunMode_string',
    },
  ],
};

export type UnitController = {
  unitControllerId: string;
  dataPointsWithValues: DataPointWithValue[];
};

export enum UnitControllerSN {
  F1_C1 = '0215F532',
  F1_C2 = '0215F696',
  F1_C3 = '0215F459',
  F1_C4 = '0215F8F5',
  F1_C5 = '0215F71F',
  F1_C6 = '0215F520',
  F1_C7 = '0215F6CE',

  F2_A1 = '0216F9BA',
  F2_A2 = '0216F9E0',
  F2_A3 = '0215F66F',
  F2_A4 = '0216F9FA',
  F2_A5 = '0215F3FD',
  F2_A6 = '0215F675',
  F2_A7 = '0215F61A',
  F2_A8 = '0215F701',

  F1_D1 = '0215F509',
  F1_D2 = '0216F9AF',
  F1_D3 = '0215F48C',
  F1_D4 = '0215F671',
  F1_D5 = '0215F38E',
  F1_D6 = '0215F423',
  F1_D7 = '0215F525',
  F1_D8 = '0215F4B4',

  F2_B1 = '0215F454',
  F2_B2 = '0215F4DA',
  F2_B3 = '0215F4D2',
  F2_B4 = '0215F62C',
  F2_B5 = '0215F4DD',
  F2_B6 = '0215F5B5',
  F2_B7 = '0215F64B',
  F2_B8 = '0215F40E',
}

export const getUnitControllerDataPointsWithValues = (
  dataPointsWithValues: DataPointWithValue[],
): UnitController[] => {
  let f2_b1DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_B1,
    dataPointsWithValues: [],
  };

  let f2_b2DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_B2,
    dataPointsWithValues: [],
  };

  let f2_b3DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_B3,
    dataPointsWithValues: [],
  };

  let f2_b4DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_B4,
    dataPointsWithValues: [],
  };

  let f2_b5DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_B5,
    dataPointsWithValues: [],
  };

  let f2_b6DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_B6,
    dataPointsWithValues: [],
  };

  let f2_b7DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_B7,
    dataPointsWithValues: [],
  };

  let f2_b8DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_B8,
    dataPointsWithValues: [],
  };

  let f2_a1DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_A1,
    dataPointsWithValues: [],
  };

  let f2_a2DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_A2,
    dataPointsWithValues: [],
  };

  let f2_a3DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_A3,
    dataPointsWithValues: [],
  };

  let f2_a4DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_A4,
    dataPointsWithValues: [],
  };

  let f2_a5DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_A5,
    dataPointsWithValues: [],
  };

  let f2_a6DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_A6,
    dataPointsWithValues: [],
  };

  let f2_a7DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_A7,
    dataPointsWithValues: [],
  };

  let f2_a8DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_A8,
    dataPointsWithValues: [],
  };

  let f1_c1DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_C1,
    dataPointsWithValues: [],
  };

  let f1_c2DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_C2,
    dataPointsWithValues: [],
  };

  let f1_c3DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_C3,
    dataPointsWithValues: [],
  };

  let f1_c4DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_C4,
    dataPointsWithValues: [],
  };

  let f1_c5DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_C5,
    dataPointsWithValues: [],
  };

  let f1_c6DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_C6,
    dataPointsWithValues: [],
  };

  let f1_c7DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_C7,
    dataPointsWithValues: [],
  };

  let f1_d1DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_D1,
    dataPointsWithValues: [],
  };

  let f1_d2DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_D2,
    dataPointsWithValues: [],
  };
  let f1_d3DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_D3,
    dataPointsWithValues: [],
  };

  let f1_d4DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_D4,
    dataPointsWithValues: [],
  };

  let f1_d5DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_D5,
    dataPointsWithValues: [],
  };

  let f1_d6DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_D6,
    dataPointsWithValues: [],
  };

  let f1_d7DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_D7,
    dataPointsWithValues: [],
  };

  let f1_d8DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_D8,
    dataPointsWithValues: [],
  };

  const pointNames = Beaumont_Device_Points_Config.UNIT_POINTS.map((point) =>
    point.pointName.toLowerCase(),
  );

  f2_b1DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_b1DataPointsWithValues.unitControllerId,
    );

  f2_b2DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_b2DataPointsWithValues.unitControllerId,
    );

  f2_b3DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_b3DataPointsWithValues.unitControllerId,
    );

  f2_b4DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_b4DataPointsWithValues.unitControllerId,
    );

  f2_b5DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_b5DataPointsWithValues.unitControllerId,
    );

  f2_b6DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_b6DataPointsWithValues.unitControllerId,
    );

  f2_b7DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_b7DataPointsWithValues.unitControllerId,
    );

  f2_b8DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_b8DataPointsWithValues.unitControllerId,
    );

  f2_a1DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_a1DataPointsWithValues.unitControllerId,
    );

  f2_a2DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_a2DataPointsWithValues.unitControllerId,
    );

  f2_a3DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_a3DataPointsWithValues.unitControllerId,
    );

  f2_a4DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_a4DataPointsWithValues.unitControllerId,
    );

  f2_a5DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_a5DataPointsWithValues.unitControllerId,
    );

  f2_a6DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_a6DataPointsWithValues.unitControllerId,
    );

  f2_a7DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_a7DataPointsWithValues.unitControllerId,
    );

  f2_a8DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_a8DataPointsWithValues.unitControllerId,
    );

  f1_c1DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_c1DataPointsWithValues.unitControllerId,
    );

  f1_c2DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_c2DataPointsWithValues.unitControllerId,
    );

  f1_c3DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_c3DataPointsWithValues.unitControllerId,
    );

  f1_c4DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_c4DataPointsWithValues.unitControllerId,
    );

  f1_c5DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_c5DataPointsWithValues.unitControllerId,
    );

  f1_c6DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_c6DataPointsWithValues.unitControllerId,
    );

  f1_c7DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_c7DataPointsWithValues.unitControllerId,
    );

  f1_d1DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_d1DataPointsWithValues.unitControllerId,
    );

  f1_d2DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_d2DataPointsWithValues.unitControllerId,
    );

  f1_d3DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_d3DataPointsWithValues.unitControllerId,
    );

  f1_d4DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_d4DataPointsWithValues.unitControllerId,
    );

  f1_d5DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_d5DataPointsWithValues.unitControllerId,
    );

  f1_d6DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_d6DataPointsWithValues.unitControllerId,
    );

  f1_d7DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_d7DataPointsWithValues.unitControllerId,
    );

  f1_d8DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_d8DataPointsWithValues.unitControllerId,
    );

  return [
    f2_b1DataPointsWithValues,
    f2_b2DataPointsWithValues,
    f2_b3DataPointsWithValues,
    f2_b4DataPointsWithValues,
    f2_b5DataPointsWithValues,
    f2_b6DataPointsWithValues,
    f2_b7DataPointsWithValues,
    f2_b8DataPointsWithValues,
    f2_a1DataPointsWithValues,
    f2_a2DataPointsWithValues,
    f2_a3DataPointsWithValues,
    f2_a4DataPointsWithValues,
    f2_a5DataPointsWithValues,
    f2_a6DataPointsWithValues,
    f2_a7DataPointsWithValues,
    f2_a8DataPointsWithValues,
    f1_c1DataPointsWithValues,
    f1_c2DataPointsWithValues,
    f1_c3DataPointsWithValues,
    f1_c4DataPointsWithValues,
    f1_c5DataPointsWithValues,
    f1_c6DataPointsWithValues,
    f1_c7DataPointsWithValues,
    f1_d1DataPointsWithValues,
    f1_d2DataPointsWithValues,
    f1_d3DataPointsWithValues,
    f1_d4DataPointsWithValues,
    f1_d5DataPointsWithValues,
    f1_d6DataPointsWithValues,
    f1_d7DataPointsWithValues,
    f1_d8DataPointsWithValues,
  ];
};
